import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminView from '../views/AdminView.vue'
import axios from "axios";
import store from "@/store";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/smartroom',
    name: 'smartroom',
    component: () => import(/* webpackChunkName: "smartroom" */ '@/views/SmartroomView.vue')
  },
  {
    path: "/smartroom/:idxCompany",
    name: 'adm_smartroom',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/SmartroomView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/LoginView.vue')
  },
  {
    path: '/login_app',
    name: 'login_app',
    component: () => import(/* webpackChunkName: "login" */ '@/views/LoginAppView')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/SignupView.vue')
  },
  {
    path: '/signup/:domain',
    name: 'signup_company',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/SignupView.vue')
  },
  {
    path: '/signup_app',
    name: 'signup_app',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/SignupAppView.vue')
  },

  {
    path: '/find',
    name: 'find',
    component: () => import(/* webpackChunkName: "signup" */ '@/views/find')
  },

  {
    path: '/adm',
    name: 'admin',
    component: AdminView
  },
  {
    path: '/company',
    name: 'company',
    component: () => import(/* webpackChunkName: "company" */ '@/views/CompanyView')
  },
  {
    path: '/manager/:lev',
    name: 'manager_lev',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ManagerView')
  },
  {
    path: '/manager',
    name: 'manager',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ManagerView')
  },
  /*{
    path: '/manager/N',
    name: 'manager_n',
    component: () => import(/!* webpackChunkName: "manager" *!/ '@/views/ManagerView')
  },*/
  {
    path: '/conference',
    name: 'conference',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceView')
  },
  {
    path: "/conference/:idxCompany",
    name: 'adm_conference',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceView')
  },
  {
    path: '/conference_add',
    name: 'conference_add',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceAddView.vue')
  },
  {
    path: '/conference_view/:idx_meeting',
    name: 'conference_view',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceAddView.vue')
  },
  {
    path: '/conference_data/:idx_meeting',
    name: 'conference_data',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceDataView.vue')
  },

  {
    path: '/conference_modify/:idx',
    name: 'conference_modify',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/ConferenceAddView.vue')
  },
  { // 회의록 작성 페이지
    path: '/minutes/:idx',
    name: 'minutes',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/minutes')
  },

  { // 회의록 작성 페이지
    path: '/minutes_view/:idx',
    name: 'minutes_view',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/minutesView')
  },

  {
    path: '/member',
    name: 'member',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/MemberView')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/dashboardView')
  },

  {
    path: "/member/:idxCompany",
    name: 'adm_member',
    component: () => import(/* webpackChunkName: "manager" */ '@/views/MemberView')
  },
  {
    path: "/part",
    name: 'company_part',
    // component: () => import(/* webpackChunkName: "manager" */ '@/components/member/partComponent')
    component: () => import('@/views/part')
  },
  {
    path: "/position",
    name: 'position',
    component: () => import('@/views/position')
  },

  { // 리뷰 관리
    path: "/review/:idxMeeting",
    name: 'review',
    component: () => import('@/views/review.vue')
  },

  { // 리뷰 관리
    path: "/review_make/:idxMeeting",
    name: 'review_make',
    component: () => import('@/views/reviewMake.vue')
  },

  { // 리뷰 관리 목록
    path: "/review_config_list",
    name: 'review_config_list',
    component: () => import('@/views/review_config_list')
  },

  { // 리뷰 관리
    path: "/review_result/:idxMeeting",
    name: 'review_result',
    component: () => import('@/views/review_result.vue')
  },

  /*{ // 리뷰 관리
    path: "/review_config",
    name: 'review_config',
    component: () => import('@/views/review_config')
  },*/

  {
    path: "/app_smart_list/:room_idx?",
    name: 'app_smart_list',
    component: () => import('@/views/AppSmartRoomView.vue')
  },
  {
    path: "/app_meeting_list",
    name: 'app_meeting_list',
    component: () => import('@/views/AppMeetingView.vue')
  },

  {
    path: "/app_meeting_tmp/:idx",
    name: 'app_meeting_tmp',
    component: () => import('@/components/app/page/tmp.vue')
  },

  { // 회의 데이터 내용 불러오기
    path: "/app_meeting_view/:idx_meeting/:idx_slide",
    name: 'app_meeting_view',
    component: () => import('@/components/app/page/app_meeting_view.vue')
  },

  {
    path: "/app_review/:idxMeeting",
    name: 'app_review',
    component: () => import('@/components/app/review.vue')
  },

  {
    path: "/app_minutes/:idxMeeting",
    name: 'app_minutes',
    component: () => import('@/components/app/minutes.vue')
  },

  {
    path: "/app_meeting",
    name: 'app_',
    component: () => import('@/components/app/app_meeting.vue')
  },
  {
    path: "/app_meeting/:idx_meeting",
    name: "app_edit",
    component: () => import('@/components/app/app_meeting.vue')
  },

  {
    path: "/app_action_plan/:idxMeeting",
    name: 'app_action_plan', 
    component: () => import('@/components/app/app_actionPlan.vue')
  },

  {
    path: "/app_action_plan_list/:idxMeeting",
    name: 'app_action_plan_list', 
    component: () => import('@/components/app/app_actionPlanList.vue')
  },

  // {
  //   path: "/data_graph",
  //   name: 'data_graph',
  //   component: () => import('@/views/AppDatagraphView.vue')
  // },
  {
    path: "/data_graph/:idx_smartroom",
    name: 'data_graph',
    component: () => import('@/views/AppDatagraphView.vue')
  },

  {
    path: "/service",
    name: 'service',
    component: () => import('@/views/service.vue')
  }, {
    path: "/plans",
    name: 'plans',
    component: () => import('@/views/plans.vue')
  }, {
    path: "/notice",
    name: 'notice',
    component: () => import('@/views/notice.vue')
  }, {
    path: "/help",
    name: 'help',
    component: () => import('@/views/help.vue')
  },

  {
    path: "/smart_board/:room_idx",
    name: 'smart_board',
    component: () => import('@/views/smartBoard.vue')
  },
  {
    path: "/smart",
    name: 'smart',
    component: () => import('@/views/smartBoard.vue')
  },
  {
    path: "/room_list",
    name: 'room_list',
    component: () => import('@/views/roomList.vue')
  },

  {
    path: "/reserve",
    name: 'reserve',
    component: () => import('@/views/reserveList.vue')
  },

  {
    path: "/policy/info",
    name: 'Policy_info',
    component: () => import('@/views/Policy_info.vue')
  },
  {
    path: "/policy/agree",
    name: 'Policy_agree',
    component: () => import('@/views/Policy_agree.vue')
  },

  {
    path: "/config",
    name: 'config',
    component: () => import('@/views/configView.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// console.log(router);

router.beforeEach(async (to, from, next) => {
  // TODO: 로그인 여부 확인
  // 라우터 가드
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const { data } = await axios.get("/new_api/account/check");
    if (data.err_code === 0) {
      if (data.contents === null) {
        alert('로그인 후 이용 가능 합니다.');
        next({ name: 'login' });
      } else {
        const idx = data.contents.idxMember;
        store.commit('setAccount', idx || 0);
        localStorage.setItem('authorization', data.contents.newToken.accessToken);
        const res = await getMyInfo();
        if (res) {
          next();
        } else {
          alert('로그인 후 이용 가능 합니다.');
          next({ name: 'login' });
        }
      }
    } else if (data.err_code === 401) {
      await logout();
      alert('로그인 후 이용 가능 합니다.');
      next({ name: 'login' });
    } else {
      // 로그아웃 처리
      alert('로그인 후 이용 가능 합니다.');
      next({ name: 'login' });
    }
    // next();

  }
  else {
    // console.log(to.name);
    /*console.log(to);
    console.log(from);
    console.log(next);*/
    if (
      to.name !== 'app_smart_list' &&
      to.name !== 'app_meeting_list' &&
      to.name !== 'app_meeting_tmp' &&
      to.name !== 'app_meeting_view' &&
      to.name !== 'app_review' &&
      to.name !== 'app_action_plan' &&
      to.name !== 'app_action_plan_list'
    ) {  // app 관련 페이지 예외처리
      console.log(to.name);
      const authorization = localStorage.getItem('authorization');
      if (authorization) {
        const res = await axios.get("/new_api/account/check");
        if (res.status === 200) {
          const data = res.data;
          if (data.err_code === 0) {
            /*const idx = data.contents.idxMember;
            store.commit('setAccount', idx || 0);*/
            localStorage.setItem('authorization', data.contents.newToken.accessToken);
            const res = await getMyInfo();
            if (res) {
              next();
            }
          }
          else {
            await logout();
            next({ name: 'login' });
          }
        }
        else {
          await logout();
          next({ name: 'login' });
        }
      }
      next();
    }
    else {
      next();
      // console.log(to.name);
    }

  }
})


const logout = async () => {
  // 로그아웃 처리
  localStorage.removeItem('authorization');
  store.commit('setAccount', 0);
  store.commit('setLevel', 0);
  store.commit('setUid', '');
}

const getMyInfo = async () => {
  // const url = `/new_api/member/${idx}`;
  const url = `/new_api/member/me`;
  await axios.get(url).then(({ data }) => {
    if (data.err_code === 0) {
      const contents = data.contents;
      const myInfo = {
        idxMember: contents.idxMember,
        idxCompany: contents.idxCompany,
        uid: contents.uid,
        phone: contents.phone,
        name: contents.name,
        mlevel: contents.mlevel,
        email: contents.email,
        status: contents.status,
        idxCompanyDept: contents.idxCompanyDept,
        position: contents.position,
        isEvent: contents.isEvent,
        regCompany: contents.regCompany,
      }
      store.commit('setMyInfo', myInfo);
      /*store.commit('setLevel', data.contents.mlevel);
      store.commit('setUid', data.contents.uid);*/
      return true;
    } else {
      return false;
    }
  })
}


export default router